import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../index';
import axios from 'utils/axios';
import { SourceProps } from 'types/props-obj/SourceProps';
const initialState: SourceProps = {
    apiEndPoint: "source",
    isOpen: false,
    pageNumber:1,
    last_page:1,
    pageLimit:5,
    current_page:1,
    total:0,
    list: [],
    item:null,
    error: null,
    alertPopup: false
  };
const source = createSlice({
    name: 'source',
    initialState,
    reducers: {
      
       
  
      hasError(state, action) {
        state.error = action.payload.error;
      },
      setPageNumber(state, action) {
        state.pageNumber = action.payload;
      },
      setPageLimit(state, action) {
        state.pageLimit = action.payload;
      },
      // get all source list
      getList(state, action) {
        state.list.push(action.payload);
        const replaceList = state.list.filter((liste) => liste.id != 0);
        state.list = replaceList;
      },
  
      // get source details
      setSource(state, action) {
        state.item = action.payload;
      },
  
      // GET Sources
      setSourcesSuccess(state, action) {
          state.list = action.payload.data;
          state.current_page=action.payload.current_page;
          state.last_page=action.payload.last_page;
          state.total=action.payload.total
      },

    // ADD Source
    addSourceSuccess(state, action) {
      state.list = [...state.list,action.payload];      
    },

    // EDIT Source
    editSourceSuccess(state, action) {
      var foundIndex = state.list.findIndex(x => x.id == action.payload.id);
      state.list[foundIndex] = action.payload;
    },

    deleteSourceSuccess(state, action) {
      const deleteData = state.list.filter((item) => item.id !== action.payload);
      state.list = deleteData;
    }

    }
  });
  export default source.reducer;
  export const {    getList,setPageNumber,setPageLimit} = source.actions;

  export function getSources(params:any={}) {
    return async () => {
      try {
        const response = await axios.get(initialState.apiEndPoint,{params:params});
        dispatch(source.actions.setSourcesSuccess(response.data));
      } catch (error) {
        dispatch(source.actions.hasError(error));
      }
    };
  }

  export function getSource(id: string | undefined) {
    return async () => {
      try {
        const response = await axios.get([initialState.apiEndPoint,  id].join('/'));
        dispatch(source.actions.setSource(response.data));
      } catch (error) {
        dispatch(source.actions.hasError(error));
      }
    };
  }

  export function addSource(ls:any) {
    return async () => {
      try {        
        const response = await axios.post(initialState.apiEndPoint, ls);
        dispatch(source.actions.addSourceSuccess(response.data));
      } catch (error) {
        dispatch(source.actions.hasError(error));
      }
    };
  }
  
  export function editSource(id: number | undefined,ls: any) {
    return async () => {
      try {
        const response = await axios.put([initialState.apiEndPoint,  id].join('/'), ls);
        dispatch(source.actions.editSourceSuccess(response.data));
      } catch (error) {
        dispatch(source.actions.hasError(error));
      }
    };
  }

  export function deleteSource(id: number | undefined) {
    return async () => {
      try {
        await axios.delete([initialState.apiEndPoint,  id].join('/'));
        dispatch(source.actions.deleteSourceSuccess(id));
      } catch (error) {
        dispatch(source.actions.hasError(error));
      }
    };
  }